import { type ComponentType, createContext } from 'react'

export interface BaseDialogProps {
  onClose?: () => void
  className?: string
  preventBackdropClose?: boolean
}

export type DialogComponent<T extends BaseDialogProps = BaseDialogProps> = ComponentType<T & BaseDialogProps>

export interface DialogContextValue {
  showDialog: <T extends BaseDialogProps>(
    Component: DialogComponent<T>,
    props?: Omit<T, 'onClose'>
  ) => void
  hideDialog: () => void
  isOpen: boolean
  setPreventBackdropClose: (prevent: boolean) => void // useful if you want to prevent closing while an action is loading (e.g. a fetch)
}

export const DialogContext = createContext<DialogContextValue | null>(null)
